import { initPopper } from "./utils";
export function position(modal) {
  if (modal.flash) {
    modal.popperInstance = initPopper(modal.slottedContent, 'flash');
  }
  else if (modal.position === 'left') {
    modal.popperInstance = initPopper(modal.slottedContent, 'position-left');
  }
  else if (modal.position === 'right') {
    modal.popperInstance = initPopper(modal.slottedContent, 'position-right');
  }
  else if (modal.slottedToggle) {
    // case slotted togler, show menu like overlay
    modal.popperInstance = initPopper(modal.slottedContent, 'slot', modal.toggleEl);
  }
  else if (!modal.slottedToggle && modal.position) {
    // case external trigger. when there is an external trigget and a position property
    // align the overlay to the trigger
    modal.popperInstance = initPopper(modal.slottedContent, 'external', modal.toggleEl);
  }
  else if (modal.slottedContent) {
    // open centered overlay
    modal.popperInstance = initPopper(modal.slottedContent);
  }
  modal.positioned = true;
}
